import React, { useEffect, useRef, useState } from "react";
import { generateClassName, generateStyle } from "../../../hooks/useAttributes";
import IElementProps from "../../../types/ElementProps";
import { ButtonBase, Clickable } from "../buttons/Button";
import LoadingSpinner from "../loader/LoadingSpinner";
import "./Icon.css";

interface Props extends IElementProps, Omit<ButtonBase, "size">, Clickable {
  icon: string,
  size?: number,
  loading?: boolean,
}

export default function Icon(props: Props) {

  const { icon, size, onClick, style, color, className, loading: externalLoading } = props;

  const [loading, setLoading] = useState<boolean>(false);

  const iconStyle = generateStyle({
    name: "fontSize",
    standard: 16,
    unit: "px",
    value: size
  }, {
    name: "lineHeight",
    standard: 16,
    unit: "px",
    value: size
  }, {
    name: "color",
    value: color
  }
  );

  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false }, []);

  const clickHandler = async () => {
    setLoading(true);
    await onClick?.();
    if (mounted.current) setLoading(false);
  }

  if (loading || externalLoading) {
    return (
      <LoadingSpinner
        className={className}
        size={size}
      />
    );
  }

  const iconClass = generateClassName("icon", className, {
    base: "bi-",
    value: icon
  }, {
    value: onClick,
    onTrue: "icon-clickable"
  });

  const finalStyle = style ? { ...style, ...iconStyle } : iconStyle;

  return (
    <i
      className={iconClass}
      onClick={clickHandler}
      style={finalStyle}
    />
  );
}